import React from 'react';
import './ParallaxSection.css';

const ParallaxSection = () => {
  return (
    <div className="parallax-section">
      <div className="parallax-content">
        <h1>Pan Survival in the 21st Century</h1>
        <p>
          Chimpanzees (Pan troglodytes) and bonobos (Pan paniscus) should be added to the Homo genus and given the right to freedom and independence, argue evolutionary anthropologist Itai Roffman and his colleagues.
        </p>
        <a href="http://www.pontecorboli.com/digital/OpenAccess/Roffman_Pan.pdf" target="_blank" rel="noopener noreferrer" className="parallax-link">
          Read more
        </a>
      </div>
    </div>
  );
};

export default ParallaxSection;
